import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import auth from './auth/auth'
import { library } from '@fortawesome/fontawesome-svg-core'

//faCreditCard, faUserSecret,  faHourglass, faWallet
import { faAddressBook,  faEnvelope, faFootballBall, faFutbol, faHome, faHourglassHalf, 
  faHourglassStart, faIdCard, faLayerGroup, faRunning, faSign, faSignInAlt, faArrowUp, faFilter, 
  faTimesCircle, faListAlt, faMap, faCoins, faSearch, faUsers, faFile, faClipboardList} from '@fortawesome/free-solid-svg-icons'
    
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// library.add(faUserSecret)
// library.add(faCreditCard)
library.add(faHome)
library.add(faSign)
library.add(faSignInAlt)
library.add(faAddressBook)
library.add(faEnvelope)
library.add(faIdCard)


library.add(faHourglassHalf)
library.add(faRunning)

library.add(faHourglassStart)
library.add(faFootballBall)
library.add(faFutbol)

library.add(faLayerGroup)

library.add(faArrowUp)
library.add(faFilter)
library.add(faTimesCircle)
library.add(faListAlt)
library.add(faMap)
library.add(faClipboardList)
library.add(faCoins)
library.add(faFile)

library.add(faSearch)
library.add(faUsers)


Vue.component('font-awesome-icon', FontAwesomeIcon)

import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents)


import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

// import VueAwesomeSwiper from 'vue-awesome-swiper';
// import 'swiper/css/swiper.css'

// import VueAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// import { Swiper, EffectFade, EffectCube, EffectCoverflow, EffectFlip,  Pagination, Navigation} from 'swiper';
// import 'swiper/swiper-bundle.css';
// Swiper.use([EffectFade, EffectCube, EffectCoverflow, EffectFlip, Pagination, Navigation]);
// Vue.use(VueAwesomeSwiper(Swiper));

// import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/core'
// import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// SwiperClass.use([Pagination, Mousewheel, Autoplay])
// Vue.use(getAwesomeSwiper(SwiperClass));


// import './assets/css/menu-scss/vue-sidebar-menu.scss'


Vue.use(VueAwesomeSwiper);


import "vue-lazy-youtube-video/dist/style.simplified.css";

// import { domain, clientId } from '../auth_config.json';

// Import the plugin here
// import { Auth0Plugin } from './auth';

import "./assets/css/tailwind.css";

// import ProgressBar from 'vuejs-progress-bar'
// Vue.use(ProgressBar)

// alert(`in main js`);
// document.addEventListener("deviceready", onDeviceReady, false);

// function onDeviceReady() {
      
//   alert(`device ready`);
//   // console.log(device.cordova);
//   alert(`device.cordova: ${device.cordova}`);
// }

import * as VueSpinnersCss from "vue-spinners-css";

Vue.use(VueSpinnersCss)


Vue.use(auth);
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'

//subscription changes
//npm install --save apollo-link-ws apollo-utilities
//npm install apollo-link-ws subscriptions-transport-ws --save
import { createHttpLink } from 'apollo-link-http'
import {WebSocketLink} from 'apollo-link-ws'
import { split } from 'apollo-link'
import { getMainDefinition } from 'apollo-utilities'



import authHttpHelper from './auth/auth-http-helper'

// import { HttpLink } from 'apollo-link-http';
import { onError } from 'apollo-link-error';

import { setContext } from 'apollo-link-context';

import { InMemoryCache } from 'apollo-cache-inmemory'

Vue.use(VueApollo);
// HTTP connection to the API

//subcription changes
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: 'https://p-nadi.herokuapp.com/v1/graphql'
});

import VueTelInput from 'vue-tel-input'

Vue.use(VueTelInput)

import vueCountryRegionSelect from 'vue-country-region-select'
Vue.use(vueCountryRegionSelect)


let myKey = '';

if(localStorage.hasOwnProperty('for_pnadi')){

  myKey = localStorage.getItem('for_pnadi');

}

import Toasted from 'vue-toasted';

Vue.use(Toasted)

import Clipboard from "v-clipboard";
Vue.use(Clipboard);


// you can also pass options, check options reference below
// Vue.use(Toasted, Options)


import * as VueGoogleMaps from 'vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: {
    key: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    libraries: 'places', // This is required if you use the Autocomplete plugin
    // OR: libraries: 'places,drawing'
    // OR: libraries: 'places,drawing,visualization'
    // (as you require)

    //// If you want to set the version, you can do so:
    // v: '3.26',
  },
});


// Cache implementation
const cache = new InMemoryCache();

// const authLink = new ApolloLink( async (operation, forward) => {


//   const idToken = result.data;

//   console.log(`******** Bearer ${idToken}`);

//   operation.setContext({


//     headers: {
//       authorization: `Bearer ${idToken}`

//       // this is where I set headers by getToken function
//       // If I change function getToken to real token in string type, it works then
//     }
//   });

//   return forward(operation);
// });

// const authLink = new ApolloLink( 

//    (operation, forward) => new Observable(observer => {
//       {
//         operation.setContext({

//           headers: {

//             authorization: `Bearer ${result.data}`
//           }
//         })
//       }).then(() => {
//         const subscriber = {
//           next: observer.next.bind(observer),
//           error: observer.error.bind(observer),
//           complete: observer.complete.bind(observer),
//         };
//         forward(operation).subscribe(subscriber);
//       })
//       .catch(err => {
//         observer.error(err);
//       });
//     }));

let token;

// let dev_key = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IlJqWTFRa05ET1RVMU1VTXhNRFUyT0VGR1F6SkJPVFpCUVRRMVEwVTJRMFpFTWtJM01ETTFSQSJ9.eyJodHRwczovL2hhc3VyYS5pby9qd3QvY2xhaW1zIjp7IngtaGFzdXJhLWRlZmF1bHQtcm9sZSI6InVzZXIiLCJ4LWhhc3VyYS1hbGxvd2VkLXJvbGVzIjpbInVzZXIiXSwieC1oYXN1cmEtdXNlci1pZCI6ImFwcGxlfDAwMjAzMi44MzE0ZTRlYTJiNDc0MmIzODRmNzM3ODdlZTZiN2E4Zi4wODIzIn0sIm5pY2tuYW1lIjoidGhlLWZveC04OCIsIm5hbWUiOiJGYWlleiBBbHRhbWltaSIsInBpY3R1cmUiOiJodHRwczovL3MuZ3JhdmF0YXIuY29tL2F2YXRhci82MTkxODdjODljNmFiZjdlMTU0NGIyYjBiODM0NTBkYz9zPTQ4MCZyPXBnJmQ9aHR0cHMlM0ElMkYlMkZjZG4uYXV0aDAuY29tJTJGYXZhdGFycyUyRmZhLnBuZyIsInVwZGF0ZWRfYXQiOiIyMDIwLTA4LTA0VDAwOjI3OjU5LjQxOVoiLCJlbWFpbCI6InRoZS1mb3gtODhAbGl2ZS5jb20iLCJlbWFpbF92ZXJpZmllZCI6InRydWUiLCJpc3MiOiJodHRwczovL3AtbmFkaS5ldS5hdXRoMC5jb20vIiwic3ViIjoiYXBwbGV8MDAyMDMyLjgzMTRlNGVhMmI0NzQyYjM4NGY3Mzc4N2VlNmI3YThmLjA4MjMiLCJhdWQiOiJQOHl5WTFLNjNIbWJPNVV3ZjlCZXVjT2FiOVRqakkwSyIsImlhdCI6MTU5NjU4MTcxNywiZXhwIjoxNTk2NjUzNzE3LCJhdF9oYXNoIjoidDBhQl9TOGRzd1hQMmloUElodzRwUSIsIm5vbmNlIjoic2lQYVZ4eU1zU19DWUtHeERKY2lwWDlQXzlublhKcH4ifQ.uoP3oaAeWNbZR60N_MupIc5ICkC8gQlAfxaNx79NSzcOneB6UOWFEYRYvV3IPSU7hVhWg1A0CK0Oy3CDvIKv9Nmn6aZAf2ETTgDFyAalQuz7OLCPqZPWvuSTUyef_bb_yIy3LJWg5YrqmCxMupdfCm3Oyh96ucGMnxaeH_F4Q8i64ASwKaz7IZx-6omiAfmNevEOKmf9RdPOkAWrRm05JIHgtSDKpXA5TbC8Scp2_6pEO6H0s7OikLN-2YjiTJSuK7EGCD-DonT5Ng_Q3NKArgEwvZgSI9HcFskYxuxnpZLHFciSoTGi1DcCYv64g7rMVvXMw9ooyiI23Svsh1intQ"

// console.log(`mode: ${process.env.VUE_APP_SERVER_MY_MODE}`);

const withToken = setContext(async request => {
  if (!token) {
   let result = await authHttpHelper.getToken(myKey);
    
   token = result.data;

  //  if(process.env.VUE_APP_SERVER_MY_MODE == "development"){

  //   key = dev_key
  //  }else{

  //  }


      // console.log(`******** Bearer ${token}`);
  } 

  if(token != ''){

    // console.log(`token != ''`)
    // console.log(token)
    return {
      headers: {
        authorization: `Bearer ${token}`
      }
    };
  }else{

    console.log(`token == ''`)
    // console.log(token)

    return {
      headers: {
      }
    };
  }
});

//************************************************* */

const wsLink2 = new WebSocketLink({
  uri: 'wss://p-nadi.herokuapp.com/v1/graphql',
  options: {
    reconnect: true,
    connectionsParams: async () => {
      if (!token) {
        let result = await authHttpHelper.getToken(myKey);
        
        token = result.data;

        // if(process.env.VUE_APP_SERVER_MY_MODE == "development"){

        //   key = dev_key
        //  }else{
      
        //   token = result.data;
        //  }    
          // console.log(`******** Bearer ${token}`);
      }
      return {
        headers: {
          authorization: `Bearer ${token}`
        }
      };
    }
  }

});

const getHeaders = async () => {
  const headers = {};
  
  if (!token) {
    let result = await authHttpHelper.getToken(myKey);
    
    token = result.data;

    // console.log(`******** Bearer ${token}`);
  }
  if (token) {
    headers.authorization = `Bearer ${token}`;
  }
  return headers;
};


const wsLink = new WebSocketLink({
  uri: 'wss://p-nadi.herokuapp.com/v1/graphql',
  options: {
    reconnect: true,
    lazy: true,
    timeout: 30000,
    connectionParams: async () => {
      return { headers: await getHeaders() };
    },
  }
});



const splittedLink = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)
//************************************************* */

const resetToken = onError(({ networkError }) => {
  if (networkError && networkError.statusCode === 401) {
    // remove cached token on 401 from the server
    token = undefined;
  }
});

const authFlowLink = withToken.concat(resetToken);

// const link = authFlowLink.concat(httpLink);
const link = authFlowLink.concat(splittedLink);


const apolloClient = new ApolloClient({
  // cache: cache,
  // link: authLink.concat(httpLink)

  cache: new InMemoryCache({
    addTypename: true
  }),

  link: link
});

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

// Vue.use(Auth0Plugin, {
//   // domain,
//   // clientId,
//   domain: process.env.VUE_APP_DOMAIN,
//   clientId: process.env.VUE_APP_CLIENT_ID,
//   onRedirectCallback: appState => {
//     router.push(
//       appState && appState.targetUrl
//         ? appState.targetUrl
//         : window.location.pathname
//     );
//   }
// });

//**************
// npm install --save jquery moment
// npm install --save vue-full-calendar
// import FullCalendar from 'vue-full-calendar'
// import 'fullcalendar/dist/fullcalendar.css'

// Vue.use(FullCalendar)
//**************

// import ToggleButton from 'vue-js-toggle-button'
// Vue.use(ToggleButton)

Vue.use(require('vue-moment'));

import VueFuse from 'vue-fuse'

import VueI18n from 'vue-i18n';
Vue.use(VueI18n);


// Vue.prototype.$isPinkStyle = true;

const businessView = Vue.observable({ businessView: {} });
Object.defineProperty(Vue.prototype, '$businessView', {
  get() { return businessView.businessView; },
  set(value) { businessView.businessView = value; }
});

const showMenu = Vue.observable({ showMenu: {} });
Object.defineProperty(Vue.prototype, '$showMenu', {
  get() { return showMenu.showMenu; },
  set(value) { showMenu.showMenu = value; }
});

const isPinkStyle = Vue.observable({ isPinkStyle: {} });
Object.defineProperty(Vue.prototype, '$isPinkStyle', {
  get() { return isPinkStyle.isPinkStyle; },
  set(value) { isPinkStyle.isPinkStyle = value; }
});

const layoutType = Vue.observable({ layoutType: {} });
Object.defineProperty(Vue.prototype, '$layoutType', {
  get() { return layoutType.layoutType; },
  set(value) { layoutType.layoutType = value; }
});

const countryCode = Vue.observable({ countryCode: {} });
Object.defineProperty(Vue.prototype, '$countryCode', {
  get() { return countryCode.countryCode; },
  set(value) { countryCode.countryCode = value; }
});

const userId = Vue.observable({ userId: {} });

Object.defineProperty(Vue.prototype, '$userId', {
  get() { return userId.userId; },
  set(value) { userId.userId = value; }
});

const selectedBusinessUserId = Vue.observable({ selectedBusinessUserId: {} });
Object.defineProperty(Vue.prototype, '$selectedBusinessUserId', {
  get() { return selectedBusinessUserId.selectedBusinessUserId; },
  set(value) { selectedBusinessUserId.selectedBusinessUserId = value; }
});

const selectedBusinessUser = Vue.observable({ selectedBusinessUser: {} });
Object.defineProperty(Vue.prototype, '$selectedBusinessUser', {
  get() { return selectedBusinessUser.selectedBusinessUser; },
  set(value) { selectedBusinessUser.selectedBusinessUser = value; }
});

//********************************************************************************************************** */
//PWA Section

import './registerServiceWorker'

import  VueDeviceDetector  from 'vue-device-detector';

Vue.use(VueDeviceDetector);

// let deferredPrompt;

// window.addEventListener('beforeinstallprompt', (e) => {
//   // Prevent Chrome 67 and earlier from automatically showing the prompt
//   e.preventDefault();
//   // Stash the event so it can be triggered later.
//   deferredPrompt = e;
//   // Update UI to notify the user they can add to home screen
//   addBtn.style.display = 'block';

//   addBtn.addEventListener('click', (e) => {
//     // hide our user interface that shows our A2HS button
//     addBtn.style.display = 'none';
//     // Show the prompt
//     deferredPrompt.prompt();
//     // Wait for the user to respond to the prompt
//     deferredPrompt.userChoice.then((choiceResult) => {
//         if (choiceResult.outcome === 'accepted') {
//           console.log('User accepted the A2HS prompt');
//         } else {
//           console.log('User dismissed the A2HS prompt');
//         }
//         deferredPrompt = null;
//       });

//   });
// });

// window.addEventListener('appinstalled', (evt) => {
//   console.log('a2hs installed');
// });

// // Detects if device is on iOS 
// const isIos = () => {
//   const userAgent = window.navigator.userAgent.toLowerCase();
//   return /iphone|ipad|ipod/.test( userAgent );
// }
// // Detects if device is in standalone mode
// const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

// // Checks if should display install popup notification:
// if (isIos() && !isInStandaloneMode()) {
//   this.setState({ showInstallMessage: true });
// }

//********************************************************************************************************** */

Vue.use(VueFuse)

import componentsHelpers from './classes/componentHelpers';
import i18n from './i18n'

// Vue.config.errorHandler = (err, vm, info) => {
//   // err: error trace
//   // vm: component in which error occured
//   // info: Vue specific error information such as lifecycle hooks, events etc.

//   // TODO: Perform any custom logic or log to server

//   console.log(`Error Handler, Err: ${JSON.stringify(err)}`);
//   // console.log(`Error Handler, vm: ${JSON.stringify(vm)}`);

//   console.log(`Error Handler, info: ${JSON.stringify(info)}`);

//   console.log(`Error Handler, $apollo: ${JSON.stringify(Vue.$apollo)}`);

//   console.log(`Error Handler, just apollo: ${JSON.stringify(Vue.apollo)}`);


// //   componentsHelpers.sendError(vue.$apollo, 0,'Profile', 'profileUpdate', 'signUpMutate',
// //   `Error: Phone is already registered: ${phone}`);

// //  componentsHelpers.toastIt(vue.$, 'Error: Phone is already registered', 3, 'outline', true);  
// };


// window.onerror = function(message, source, line, column, error) {
//   console.log('ONE ERROR HANDLER TO RULE THEM ALL:', message);


//   console.log(`window.onerror, message: ${JSON.stringify(message)}`);
//   // console.log(`window.onerror, source: ${JSON.stringify(source)}`);

//   // console.log(`window.onerror, line: ${JSON.stringify(line)}`);
//   // console.log(`window.onerror, column: ${JSON.stringify(column)}`);

//   // console.log(`window.onerror, error: ${JSON.stringify(error)}`);


//   // console.log(`window.onerror, $apollo: ${JSON.stringify(Vue.$apollo)}`);

//   // console.log(`window.onerror, just apollo: ${JSON.stringify(Vue.apollo)}`);  

//   return true;
// }


import vClickOutside from 'v-click-outside';

Vue.use(vClickOutside);


Vue.config.productionTip = false

let vm = new Vue({
  apolloProvider,
  router,
  store,
  i18n,

  // watch: {
  //   $route: function(current) {
  //     console.log(`watching route with ${current}`);
  //     const route = this.$router.options.routes.find(route => route.path === current.path)

  //     if (route && Array.isArray(route.children)) {
  //       this.children = route.children
  //     } else if (route) {
  //       this.children = []
  //     }
  //   }
  // },

  render: h => h(App)
}).$mount('#app')

window.vm = vm;

// console.log(`window.vm: ${JSON.stringify(window.vm)}`)

